var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-groups-screen"},[_c('div',{staticClass:"my-groups-screen__wrapper"},[_c('span',{staticClass:"my-groups-screen__title"},[_vm._v("Мои каналы")]),_c('MyGroupsTabs',{on:{"loadMyGroups":_vm.loadMyGroups}}),_c('MyGroups',{attrs:{"groups":_vm.getMyGroups}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }